var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyBtnDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1100_1513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5581 46.0582C35.0167 46.0582 45.1163 35.9586 45.1163 23.5C45.1163 11.0415 35.0167 0.941895 22.5581 0.941895C10.0996 0.941895 0 11.0415 0 23.5C0 35.9586 10.0996 46.0582 22.5581 46.0582Z",
    fill: "#4447E0",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7456 12.9419H18.2544C17.6836 12.9419 17.1777 12.9418 16.7516 12.9802C16.2894 13.0217 15.8386 13.1136 15.3924 13.3424C14.9463 13.5713 14.6113 13.8824 14.3117 14.2315C14.0355 14.5534 13.7454 14.9617 13.4181 15.4223L13.3906 15.4611L12.6744 16.4689L12.6375 16.5209C12.1756 17.1707 11.7714 17.7395 11.4942 18.2455C11.1947 18.7922 10.9811 19.3721 11.0013 20.047C11.0215 20.7218 11.2694 21.2883 11.601 21.8167C11.908 22.3059 12.3455 22.8502 12.8454 23.4721L19.2395 31.4283C19.6555 31.946 20.0092 32.386 20.3242 32.7222C20.651 33.071 21.0138 33.3953 21.476 33.6083C22.4418 34.0531 23.5582 34.0531 24.524 33.6083C24.9861 33.3953 25.349 33.071 25.6758 32.7222C25.9908 32.386 26.3444 31.946 26.7604 31.4283L33.1545 23.4721C33.6543 22.8502 34.092 22.3059 34.3989 21.8167C34.7306 21.2883 34.9784 20.7218 34.9987 20.047C35.0188 19.3721 34.8053 18.7922 34.5057 18.2455C34.2286 17.7395 33.8244 17.1707 33.3624 16.5209L32.5818 15.4223C32.2545 14.9617 31.9645 14.5534 31.6882 14.2315C31.3886 13.8824 31.0537 13.5713 30.6075 13.3424C30.1613 13.1136 29.7106 13.0217 29.2484 12.9802C28.8223 12.9418 28.3164 12.9419 27.7456 12.9419ZM20.4003 18.9127C20.7677 18.3699 20.6187 17.6365 20.0677 17.2746C19.5167 16.9128 18.7721 17.0594 18.4048 17.6023L17.8052 18.4882C17.155 19.4489 17.2238 20.7165 17.9742 21.6036L20.2801 24.3293C20.704 24.8305 21.4602 24.8982 21.969 24.4805C22.4778 24.063 22.5465 23.3181 22.1225 22.8169L19.8166 20.0911C19.7461 20.0079 19.7397 19.8889 19.8007 19.7987L20.4003 18.9127Z",
    fill: "#4447E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1100_1513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.1163,
    height: 45.1163,
    fill: "white",
    transform: "translate(0 0.941895)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyBtnDashboard);
export default __webpack_public_path__ + "static/media/buy_btn_dashboard.208bc402fe48945062b5a9108be479f8.svg";
export { ForwardRef as ReactComponent };